/* eslint-disable @typescript-eslint/no-explicit-any */
import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";
import type { SortOrderValue } from "@src/shared/constants/sort-order.constants";

interface GetTicketsParams {
  page?: number;
  pageSize?: number;
  search?: string;
  status?: string;
  orderBy?: string;
  orderDirection?: SortOrderValue | Lowercase<SortOrderValue>;
  [key: string]: any;
}

export class TicketService {
  async getTickets(query: GetTicketsParams) {
    return apiService.get("/tickets", { params: sanitizeQueryParams(query) });
  }

  async getTicket(id: string | number) {
    return apiService.get(`/tickets/${id}`);
  }

  async updateTicketStatus(id: string | number, data: { status: string }) {
    return apiService.patch(`/tickets/${id}/status`, data);
  }

  async updateTicket(id: string | number, data: any) {
    return apiService.put(`/tickets/${id}`, data);
  }

  async addTicketThread(id: string | number, data: { message: string; userId?: number }) {
    return apiService.post(`/tickets/${id}/thread`, data);
  }

  async escalateTicket(id: string | number) {
    return apiService.patch(`/tickets/${id}/escalate`, {});
  }
}

export const ticketService = new TicketService();
